import Vue from 'vue'
import Toasted from "vue-toasted"

Vue.use(Toasted, { theme: 'lt', position: 'bottom-right', duration: 3000 })

Vue.toasted.register('saved', 'Einstellungen wurden aktualisiert.', {
    position: 'bottom-right',
    theme: 'lt',
    type: 'success',
    duration: 3000
})

Vue.toasted.register('success', 'Aktion erfolgreich ausgeführt.', {
    position: 'bottom-right',
    theme: 'lt',
    type: 'success',
    duration: 3000
})

Vue.toasted.register('error', 'Es ist ein Fehler aufgetreten', {
    position: 'bottom-right',
    theme: 'lt',
    type: 'error',
    duration: 3000
}) 